import { GET_LIST_KEGIATAN, GET_ID_KEGIATAN } from "../actions/actionKegiatan";

const initialState = {
    getListKegiatanResult: false,
    getListKegiatanLoading: false,
    getListKegiatanError: false,

    getIdKegiatanResult: false,
};

const indexReducerKegiatan = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_KEGIATAN:
            return {
                ...state,
                getListKegiatanResult: action.payload.data,
                getListKegiatanLoading: action.payload.loading,
                getListKegiatanError: action.payload.errorMessage,
            };
        case GET_ID_KEGIATAN:
            return {
                ...state,
                getIdKegiatanResult: action.payload.data,
            };
        default:
            return state;
    }
};

export default indexReducerKegiatan;
